import { useQuery } from "@tanstack/react-query";
import { getMenu } from "../api/Api";
import RenderPage from "./RenderPage";
import Progress from './Progress';


export default function MenuLoader(props) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["menu"],
    queryFn: getMenu,
  });

  if (isLoading) return <Progress />;
  if (error) return <p>Error: {error.message}</p>;

  return <RenderPage
    pizzas={data.pizzas}
    order={props.order}
    setOrder={props.setOrder}
  />;
}
